import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from 'features/auth';

import type { GuardProps } from 'types/auth';

interface LocationState {
  from?: string;
}

export default function GuestGuard({ children }: GuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated) {
    const state = location.state as LocationState | null;

    return <Navigate to={state?.from || '/dashboard'} replace />;
  }

  return children;
}
